import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { count, countUnique, sum } from '@utils/summaries';
import { MaterialMap } from '@consts/materials';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';

import type { Materials } from '@consts/materials';

interface GlobalRankByMaterialProps {
    dateRange: { startDate: string; endDate: string };
    material: Materials;
}

export const GlobalRankByMaterial = ({ dateRange, material }: GlobalRankByMaterialProps) => {
    const materialId = MaterialMap[material];

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.PRODUCTS_LOCATION_GLOBAL_RANK_OF_MATERIAL,
        params: { ...dateRange, materialId },
    });

    return (
        <BaseReport
            title={`Global Rank for ${material} Cut Volume`}
            description={`This table shows you the number of cuts of ${material} film for each location, along with their world rank, for the entire date range above.`}
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Location Name', 'Reseller Name', `${material} Cuts`, 'World Rank'],
                data: data.map((item) => [item.locationName, item.resellerName, item.materialCuts, item.worldRank]),
                summaries: [countUnique, countUnique, sum, count],
                sort: [basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
